import React from "react";
import { string } from "prop-types";
import styles from "./Chevron.module.sass";
const rotationForDirection = direction => {
  switch (direction) {
    case "up":
      return -180;
    case "left":
      return 90;
    case "down":
      return 0;
    default:
      return -90;
  }
};
const arrow = angle => /*#__PURE__*/React.createElement("svg", {
  width: "31",
  height: "30",
  viewBox: "0 0 31 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigation/chevron_down"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0137 10.375L15.7637 16.125L21.5137 10.375L23.2637 12.125L15.7637 19.625L8.26367 12.125L10.0137 10.375Z",
  fill: "#072448",
  transform: `translate(20.000000, 20.000000) translate(-20.000000, -20.000000)`
})));
const Chevron = props => /*#__PURE__*/React.createElement("div", {
  className: `${styles["chevron"]} ${props.className || ""} ${styles[props.direction || "right"] || ""}`
}, arrow(rotationForDirection(props.direction)));
Chevron.displayName = "Chevron";
Chevron.propTypes = {
  className: string,
  direction: string
};
export default Chevron;